import { render, staticRenderFns } from "./Leodata.vue?vue&type=template&id=6134d5c3"
import script from "./Leodata.vue?vue&type=script&lang=js"
export * from "./Leodata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports